import ConstituentExportFieldName from '@/constants/constituents/ConstituentExportFieldName';
import translate from '@/lib/intl/translate';
import type ConstituentExportField from '@/types/api/ConstituentExportField';

const CsvExportHouseholdInformationFields: Omit<
  ConstituentExportField,
  'value'
>[] = [
  {
    fieldLabel: translate('CONSTITUENT_EXPORT_PREFERRED_HOUSEHOLD_GREETING'),
    fieldName: ConstituentExportFieldName.PREFERRED_HOUSEHOLD_GREETING,
  },
  {
    fieldLabel: translate('CONSTITUENT_EXPORT_SPOUSE_PARTNER_NAME'),
    fieldName: ConstituentExportFieldName.SPOUSE_PARTNER_NAME,
  },
  {
    fieldLabel: translate('CONSTITUENT_EXPORT_SPOUSE_PARTNER_EMAIL'),
    fieldName: ConstituentExportFieldName.SPOUSE_PARTNER_EMAIL,
  },
];

export default CsvExportHouseholdInformationFields;
